var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrganisation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 31 29.5",
    style: {
      enableBackground: "new 0 0 31 29.5",
      fill: "currentColor"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20.8,
    y: 19.1,
    width: 3,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.8,
    y: 13.2,
    width: 3,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8,7.3V1.4H2.1v26.8h26.8V7.3H15.8z M7.6,25.2H4.9v-3h2.7V25.2z M7.6,19.2H4.9v-3h2.7V19.2z M7.6,13.3H4.9v-3h2.7V13.3z  M7.6,7.3H4.9v-3h2.7V7.3z M13.1,25.2h-2.7v-3h2.7V25.2z M13.1,19.2h-2.7v-3h2.7V19.2z M13.1,13.3h-2.7v-3h2.7V13.3z M13.1,7.3 h-2.7v-3h2.7V7.3z M26,25.1H15.6V22V10.2H26V25.1z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.7,
    y: 19.2,
    width: 2.7,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.7,
    y: 13.3,
    width: 2.7,
    height: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganisation);
export default __webpack_public_path__ + "static/media/organisation.5efe0841a3ce0ade0a50740f8b88b983.svg";
export { ForwardRef as ReactComponent };